import { Controller } from '@hotwired/stimulus'
import { AddressAPI } from "../utils/address_api"
import { GooglePlaceAPI } from "../utils/google_place_api"

export default class extends Controller {
  static targets = ["deliveryAddress", "invalidAddress"]

  connect() {
    if (document.readyState === "complete") {
      this.initGoogleMaps()
    } else {
      window.addEventListener("load", (event) => {
      this.initGoogleMaps()
      })
    }
    this.bindEvents()
    this.validateDeliveryAddress()
  
  }

  initGoogleMaps() {
    let addressField = document.querySelector("#ship-address");
    this.addressAPI = AddressAPI()

    if(this.deliveryAddressTarget.dataset.address != 'Find your address') {
      this.deliveryAddressTarget.value = this.deliveryAddressTarget.dataset.address
    }

    let autocomplete = GooglePlaceAPI().init(addressField)
    autocomplete.addListener("place_changed", () => {
      let address = GooglePlaceAPI().getAddressInformation(autocomplete)
      if($.isEmptyObject(address)) { return }

      if(this.addressAPI.isCompleteAddress(address)) {
        let itemsOnCart = 0
        this.deliveryAddressTarget.classList.add("validating")

        this.addressAPI.isDeliveryAddressValid(address)
        .then(() => {
          let shoppingCart = document.querySelector(".shopping-bag-item-count")
          let coordinates = [address.longitude, address.latitude]
          itemsOnCart = parseInt(shoppingCart.innerText)
          this.deliveryAddressTarget.classList.remove("validating")
          $("[data-target='address-search.invalidAddress']").popover("hide")

          if(itemsOnCart > 0) {
            this.showChangeAddressModal(address, coordinates)
          } else {
            this.updateShippingAddress(address, coordinates)
          }
        })
        .catch((error) => {
          this.addressAPI.showInvalidAddressMsg(error.in_exclusion_area, this.deliveryAddressTarget)
          this.addressAPI.saveInvalidShippingAddress(addressField.value, address.place)
        })
      } else if(this.addressAPI.isMissingStreetNumber(address)) {
        this.displayStreetNumberPopover()
        this.invalidAddressTarget.dataset.validForDeliver = "false"
        document.cookie = "isValid=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
      } else {
        this.addressAPI.saveInvalidShippingAddress(addressField.value, address.place)
        this.addressAPI.showInvalidAddressMsg(false, this.deliveryAddressTarget)
        document.cookie = "isValid=;expires=Thu, 01 Jan 1970 00:00:01 GMT"
      }
    })

    this.bindEvents()
    this.validateDeliveryAddress()
  }

  displayStreetNumberPopover() {
    this.addressAPI = AddressAPI()

    this.addressAPI.missingStreetNumberMessage()

    $("[data-target='address-search.invalidAddress']").popover("show")
   }

  clearAddress(e) {
    e.preventDefault
    let addressInput = document.querySelector("#ship-address")

    addressInput.value = ""
    e.target.classList.add("d-none")
    $("[data-target='address-search.invalidAddress']").popover("dispose")
  }

  bindEvents() {
    let clearButton = document.querySelector(".data-clear-input")
    document.querySelector("#ship-address").addEventListener("mousedown", () => {
      clearButton.classList.remove("d-none")
      $("[data-target='address-search.invalidAddress']").popover("hide")
      $('#deliver-to-wrapper').popover('hide');
    })

    document.querySelector("#ship-address").addEventListener("keydown", (e) => {
      clearButton.classList.remove("d-none")
      $("[data-target='address-search.invalidAddress']").popover("hide")
      $('#deliver-to-wrapper').popover('hide');
    })

    document.querySelector("#ship-address").addEventListener("focusout", (e) => {
      let defaultAddress = this.deliveryAddressTarget.dataset.address

      if(e.target.value.trim() == "" && defaultAddress != "Find your address") {
        e.target.value = defaultAddress
      }
    })
  }

  validateDeliveryAddress() {
    let invalidForDeliver = this.invalidAddressTarget.dataset.validForDeliver == "false"
    let inExclusionArea = this.invalidAddressTarget.dataset.inExclusionArea == "true"
    let addressInput = document.querySelector(".pac-target-input")

    if(invalidForDeliver && (addressInput !== null && addressInput.value != "")) {
      this.addressAPI.showInvalidAddressMsg(inExclusionArea, this.deliveryAddressTarget)
     }
  }

  showChangeAddressModal(address, coordinates) {
    $("#changeAddressModal").data("address", address)
    $("#changeAddressModal").data("placeName", address.place)
    $("#changeAddressModal").data("orderGuestToken", this.deliveryAddressTarget.dataset.orderGuestToken)
    $("#changeAddressModal").data("orderNumber", this.deliveryAddressTarget.dataset.orderNumber)
    $("#changeAddressModal").data("coordinates", coordinates)
    $("#changeAddressModal").modal('show');
  }

  updateShippingAddress(address, coordinates) {
    this.addressAPI.setCookies(address.place, address.zipcode, address.city, address.state, coordinates)
    if(this.deliveryAddressTarget.dataset.userPresent == "true") {
      this.addressAPI.saveAddress(address)
    } else {
      Turbolinks.visit(location.toString())
    }
  }

}
